import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookies from 'js-cookie'
import config from '../config'

Vue.use(VueI18n)

export default ({ app }) => {
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch
  app.i18n = new VueI18n({
    locale: cookies.get(config.COOKIE_NAME__LOCALE) || config.defaultLocale,
    fallbackLocale: config.defaultLocale,
    messages: {
      en: require('~/locales/en.json'),
      'zh-CN': require('~/locales/zh-CN.json')
    }
  })

  app.i18n.path = (link) => {
    if (app.i18n.locale === app.i18n.fallbackLocale) {
      return `/${link}`
    }

    return `/${app.i18n.locale}/${link}`
  }
}
